import axios from "axios"

export default {
  loadGuideList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/about`).then(res => {
        resolve(res.data);
        commit('updateGuideList', res.data);
      }, error => {
        reject(error)
      })
    })
  },
}
